<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-13 16:30:53
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-04-01 17:24:19
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\datePicker\index.vue
-->
<template>
  <div>
    <DhcFieldInput v-model="formOption" :inputData="formOption.value" placeholder="点击选择日期" :disable="disable" @changeFieldData="changeFieldData"></DhcFieldInput>
    <van-popup v-model="formOption.isPopFlag" position="bottom">
      <van-datetime-picker v-model="currentDate" type="date" title="选择日期" :min-date="minDate" :max-date="maxDate"
                           :formatter="formatter" @confirm="onDataPickerConfirm" @cancel="formOption.isPopFlag = false"
      />
    </van-popup>
  </div>
</template>
<script>
import * as dictionary from '@/assets/js/dictionary'
import {
	timestampFormat
} from '@/utils/date.js'
export default {
	props: {
		value: {
			type: Object,
			default: {}
		},
		disable: { // 禁止
			type: [Boolean, Number],
			default: false
		}
	},
	data() {
		return {
			dictionary,
			currentDate: '',
			minDate: new Date(1940, 0, 1), // 默认最小时间
			maxDate: new Date(2940, 0, 1) // 默认最大时间
		}
	},
	computed: {
		formOption: {
			get: function() {
				return this.value
			},
			set: function() {
				return
			}
		}
	},
	watch: {
		'formOption': {
			handler(newValue) {
				newValue.value ? this.currentDate = new Date(newValue.value) : this.currentDate = new Date()
				this.$emit('changePickerData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 日期选择器确认
		onDataPickerConfirm(value) {
			this.formOption.value = timestampFormat(value, 1)
			this.formOption.isPopFlag = false
		},
		formatter(type, value) {
			return `${value}${dictionary.formatterObj[type]}`
		},
		// 改变input框数据
		changeFieldData(data) {
			this.formOption = data
		}
	}
}
</script>
<style lang="scss" scoped>
</style>